<!-- NAVBAR -->
<NavbarSection />

<!-- HERO SECTION -->
<HeroSection />

<!-- FOOTER -->
<FooterSection />